import { user } from './user'
import { ppt } from './ppt'
import { order } from './order'
import { admin } from './admin'
import { goods } from './goods'

export const api = {
  user,
  ppt,
  order,
  admin,
  goods
}
